// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"5010fd9e","172":"d34c9318","393":"c4fe609e","576":"e4d0d7e3","585":"996f3043","716":"a8e5a579","867":"3f931165","966":"ba5d76e2"}[chunkId] + ".chunk.js";
};